// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview {
  max-width: 200px;
}
/*CSS classes*/
.text-tabs-1{float:left;}

.text-tabs-2{
  float:left;
  margin-left:120px;
  display:block;
  position:absolute;
}

.clearer{clear:both;}

.text-tabs-decription-2{
  float:left;
  margin-left:35px;
  height: 100px;
  max-width: 470px;
}

.p-description {
  text-overflow: ellipsis; /* will make [...] at the end */
  width: 370px; /* change to your preferences */
  white-space: nowrap; /* paragraph to one line */
  overflow:hidden; /* older browsers */
}

:host {
  height: 100vh;
  display: grid;
  grid-template-areas:
    "loginCard"
    "footer";
  grid-template-rows: 1fr auto;
}

img {
  width: 250px;
  padding: 2em;
}

.login-container {
  grid-area: loginCard;
  justify-self: center;
  text-align: center;
}

mat-card {
  width: 580px;
  height: auto;
}

mat-card form {
  padding-top: 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

mat-form-field {
  width: 100%;
  padding: 1em;
}

.form-actions {
  margin-top: 3em;
}

app-footer {
  grid-area: footer;
  font-size: 0.8rem;
}

@media(max-width: 768px) {
  mat-card {
    width: 330px;
  }
}

.progress-bar {
  padding: 0;
}

.progress {
  width: 50px;
}

.mat-input-element {
  font-size: medium;
  font-weight: 200;
}

#fileInput {
  position: absolute;
  cursor: pointer;
  z-index: 10;
  opacity: 0;
  height: 100%;
  left: 0px;
  top: 0px;
}

.mat-toolbar-single-row {
  height: auto !important;
  background: transparent;
  padding: 0;
}

.mat-toolbar-single-row button {
  width: 100px;
}

.mat-form-field {
  width: 100%;
}

.mat-mdc-form-field {
  display: block;
}

.message {
  background-color: #ddd;
  padding: 15px;
  color: #333;
  border: #aaa solid 1px;
  border-radius: 4px;
  margin: 15px 0;
}

.preview {
  max-width: 200px;
  vertical-align: middle;
}

.list-card {
  margin-top: 20px;
}

.text-inside-grid {
  position: absolute;
  left: 5px;
}

.image-inside-grid {
  height: 50px;
  position: absolute;
  right: 5px;
}


.container {
  width: 600px;
  margin: 20px auto;
}

.container h3{
  font-size: xx-large;
}

.container h4{
  font-size: x-large;
}


`, "",{"version":3,"sources":["webpack://./src/app/add-item/add-item.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA,cAAc;AACd,aAAa,UAAU,CAAC;;AAExB;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,iBAAiB;AACnB;;AAEA,SAAS,UAAU,CAAC;;AAEpB;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB,EAAE,+BAA+B;EACxD,YAAY,EAAE,+BAA+B;EAC7C,mBAAmB,EAAE,0BAA0B;EAC/C,eAAe,EAAE,mBAAmB;AACtC;;AAEA;EACE,aAAa;EACb,aAAa;EACb;;YAEU;EACV,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,UAAU;EACV,YAAY;EACZ,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;;AAGA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".preview {\n  max-width: 200px;\n}\n/*CSS classes*/\n.text-tabs-1{float:left;}\n\n.text-tabs-2{\n  float:left;\n  margin-left:120px;\n  display:block;\n  position:absolute;\n}\n\n.clearer{clear:both;}\n\n.text-tabs-decription-2{\n  float:left;\n  margin-left:35px;\n  height: 100px;\n  max-width: 470px;\n}\n\n.p-description {\n  text-overflow: ellipsis; /* will make [...] at the end */\n  width: 370px; /* change to your preferences */\n  white-space: nowrap; /* paragraph to one line */\n  overflow:hidden; /* older browsers */\n}\n\n:host {\n  height: 100vh;\n  display: grid;\n  grid-template-areas:\n    \"loginCard\"\n    \"footer\";\n  grid-template-rows: 1fr auto;\n}\n\nimg {\n  width: 250px;\n  padding: 2em;\n}\n\n.login-container {\n  grid-area: loginCard;\n  justify-self: center;\n  text-align: center;\n}\n\nmat-card {\n  width: 580px;\n  height: auto;\n}\n\nmat-card form {\n  padding-top: 20px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n\nmat-form-field {\n  width: 100%;\n  padding: 1em;\n}\n\n.form-actions {\n  margin-top: 3em;\n}\n\napp-footer {\n  grid-area: footer;\n  font-size: 0.8rem;\n}\n\n@media(max-width: 768px) {\n  mat-card {\n    width: 330px;\n  }\n}\n\n.progress-bar {\n  padding: 0;\n}\n\n.progress {\n  width: 50px;\n}\n\n.mat-input-element {\n  font-size: medium;\n  font-weight: 200;\n}\n\n#fileInput {\n  position: absolute;\n  cursor: pointer;\n  z-index: 10;\n  opacity: 0;\n  height: 100%;\n  left: 0px;\n  top: 0px;\n}\n\n.mat-toolbar-single-row {\n  height: auto !important;\n  background: transparent;\n  padding: 0;\n}\n\n.mat-toolbar-single-row button {\n  width: 100px;\n}\n\n.mat-form-field {\n  width: 100%;\n}\n\n.mat-mdc-form-field {\n  display: block;\n}\n\n.message {\n  background-color: #ddd;\n  padding: 15px;\n  color: #333;\n  border: #aaa solid 1px;\n  border-radius: 4px;\n  margin: 15px 0;\n}\n\n.preview {\n  max-width: 200px;\n  vertical-align: middle;\n}\n\n.list-card {\n  margin-top: 20px;\n}\n\n.text-inside-grid {\n  position: absolute;\n  left: 5px;\n}\n\n.image-inside-grid {\n  height: 50px;\n  position: absolute;\n  right: 5px;\n}\n\n\n.container {\n  width: 600px;\n  margin: 20px auto;\n}\n\n.container h3{\n  font-size: xx-large;\n}\n\n.container h4{\n  font-size: x-large;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
